import { IEpisode } from '@redmedical/datamodels/shared-datamodels';

import { optional } from '../utility/optional';

import { EntityWithRelations } from './entity-with-relations.type';

export const EPISODE_WITH_PAE_AND_DOCTOR = {
  id: '' as IEpisode['id'],
  Doctor: {},
  PatientAkteEintrag: {},
  ElektronischeErsatzbescheinigung: optional(),
  Versichertenkarte: optional({
    Einlesevorgang: {},
  }),
} as const;

export type EpisodeWithPaeAndDoctor = EntityWithRelations<IEpisode, typeof EPISODE_WITH_PAE_AND_DOCTOR>;
